import { initializeConnector, Web3ReactHooks } from "@web3-react/core";
import { MetaMask } from "@web3-react/metamask";
import { Network } from "@web3-react/network";
import { CoinbaseWallet } from "@web3-react/coinbase-wallet";
import { WalletConnect } from "@web3-react/walletconnect";

// BSC Chain Configuration
export const BSC_CHAIN_ID = 56;
export const BSC_RPC_URL = "https://node-bsc.pinksale.com/";

// MetaMask Connector
export const [metaMask, metaMaskHooks] = initializeConnector<MetaMask>(
  (actions) => new MetaMask({ actions })
);

// Network Connector (for BSC)
export const [network, networkHooks] = initializeConnector<Network>(
  (actions) =>
    new Network({
      actions,
      urlMap: {
        [BSC_CHAIN_ID]: BSC_RPC_URL,
      },
      defaultChainId: BSC_CHAIN_ID,
    })
);

// Coinbase Wallet Connector
export const [coinbaseWallet, coinbaseWalletHooks] =
  initializeConnector<CoinbaseWallet>(
    (actions) =>
      new CoinbaseWallet({
        actions,
        options: {
          url: BSC_RPC_URL,
          appName: "Pink Chart Admin",
        },
      })
  );

// WalletConnect Connector
export const [walletConnect, walletConnectHooks] =
  initializeConnector<WalletConnect>(
    (actions) =>
      new WalletConnect({
        actions,
        options: {
          rpc: {
            [BSC_CHAIN_ID]: BSC_RPC_URL,
          },
        },
      })
  );

// Export all connectors as array for Web3ReactProvider
export const connectors = [
  [metaMask, metaMaskHooks],
  [network, networkHooks],
  [coinbaseWallet, coinbaseWalletHooks],
  [walletConnect, walletConnectHooks],
] as any;

// Export BSC chain info
export const BSC_CHAIN = {
  id: BSC_CHAIN_ID,
  name: "BNB Smart Chain",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB",
  },
  rpcUrls: {
    default: {
      http: [BSC_RPC_URL],
    },
    public: {
      http: [BSC_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
    },
  },
  testnet: false,
} as const;
